export default __webpack_public_path__ + "static/hero-ui-components-175edaf3ce98dfec0dcf813f620c5dbe.jpg";